import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Entry } from 'contentful';

import { LocalizationService } from '../localization/localization.service';
import { ContentfulService } from '../contentful/contentful.service';

const GLOBAL_CONTENT_ID = '7H3B2MSddDs5IwcPegxtKL';

@Injectable({
  providedIn: 'root'
})
export class GlobalContentService {
  constructor(
    private localizationService: LocalizationService,
    private contentfulService: ContentfulService
  ) {}

  getGlobalContent(): Observable<Entry<any>> {
    return this.localizationService.locale.pipe(
      switchMap(() => {
        return this.contentfulService.getEntryById(
          'globalSettings',
          GLOBAL_CONTENT_ID
        );
      })
    );
  }
}
